import FormView from 'routes/ReferralForm/FormView/FormView';

export default FormView;
